module.exports = __webpack_public_path__ + "img/indent.aad65d80.svg";